export default "__VITE_ASSET__Z5zaddrz__"